/**
 * DEV DOCS
 *
 * This component create a header for the application, which reacts to redux and
 * dispatch actions to be reacted by both sidebars.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Tooltip from 'react-tooltip';
import { MdExitToApp } from 'react-icons/md';

// Asset impoort
import { ReactComponent as Logo } from '@assets/soma.svg';

// Hook import
import { useTheme } from '@hooks/useTheme';

// Action import
import { setLeftMenu } from '@store/modules/ui/actions';
import { signOut } from '@store/modules/auth/actions';

// Style import
import { Container } from './styles';

const Header: React.FC = () => {
  // Hooks
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    // Tooltip re-render fix
    Tooltip.hide();
    Tooltip.rebuild();

    // Change overflow
    handleScreenOverflow();
  });

  // Global states
  const leftMenu = useSelector(state => state.ui.left_menu);

  // Handle screen overflow
  const handleScreenOverflow = () => {
    // Get viewport
    const vw = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0,
    );

    // Handle window overflow
    const element = document.querySelector('html');
    if (element) {
      if (vw <= 768) {
        if (leftMenu) element.style.overflow = 'hidden';
        else element.style.overflow = 'auto';
      } else element.style.overflow = 'auto';
    }
  };

  // Left menu toggle
  const handleLeftMenuToggle = () => {
    // Toggle state
    dispatch(setLeftMenu(!leftMenu));

    // Change overflow
    handleScreenOverflow();
  };

  useEffect(() => {
    // Clear menu open when reside
    const handleResize = () => {
      // Get viewport
      const vw = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0,
      );

      // On mobile, default state is closed menu, but in desktop, defaults to opened
      if (vw <= 768) dispatch(setLeftMenu(false));
      else dispatch(setLeftMenu(true));

      // Change overflow
      handleScreenOverflow();
    };

    // Resize event
    window.addEventListener('resize', handleResize);

    return () => {
      // Clear resize function
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <Container>
      <section className="left">
        <button
          type="button"
          id="menu-toggle"
          onClick={handleLeftMenuToggle}
          className={leftMenu ? 'toggle open' : 'toggle'}
        >
          <span />
          <span />
          <span />
          <span />
        </button>
      </section>
      <section className="center">
        <Logo stroke={theme.font_low} fill={theme.font_low} />
      </section>
      <section className="right">
        <button type="button" onClick={() => dispatch(signOut())}>
          <MdExitToApp color={theme.font_low} size={33} />
        </button>
      </section>
    </Container>
  );
};

export { Header };
